import React, { useState, useEffect } from "react";
import { Grid, Button, Icon, Label } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { getTranslationsFile, getTranslationsFileCsvToJson } from "services/translations";
import Papa from "papaparse";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { isJson } from "utils/json";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		overflowY: "auto",
		height: "100%",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		//width: '100%',
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
	row: {
		padding: 0,
		margin: 0,
	},
};

const findKeyValues = (o, prefix, l = 0) => {
	let result = [];
	for (const key of Object.keys(o)) {
		const fullKey = prefix ? prefix + "." + key : key;
		const value = o[key];
		if (typeof value === "string") {
			result.push([fullKey, value].map((s) => `"${s.replace(/"/g, '""')}"`).join(","));
		} else if (typeof value === "object" && value) {
			result = result.concat(findKeyValues(value, fullKey, l + 1));
		}
	}
	return result;
};

export const Translations = () => {
	const [filterEN, setFilterEN] = useState(false);
	const [filterDE, setFilterDE] = useState(false);
	const [trad, setTrad] = useState({});
	const { i18n } = useTranslation();
	const getActiveLanguage = () => i18n.language || "fr";
	const lang = getActiveLanguage();
	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};

	const dispatch = useDispatch();

	const novalue = <span style={{ color: "blue" }}>!no value!</span>;
	const missing = <span style={{ color: "red" }}>!missing in files!</span>;

	useEffect(() => {
		i18n.loadLanguages(["de", "en", "fr"], (err) => {
			setTrad({
				fr: i18n.store.data.fr.translation,
				en: i18n.store.data.en.translation,
				de: i18n.store.data.de.translation,
			});
		});
	}, [i18n]);

	function convertAction(e) {
		const csvContent = e.target.files[0];
		//convert csv to json ans send data to serveur for save in a file
		Papa.parse(csvContent, {
			header: true,
			skipEmptyLines: true,
			complete: function (result) {
				let jsonData = result.data;
				dispatch(getTranslationsFileCsvToJson(jsonData)).then((res) => {});
			},
		});
	}

	const importCSV = () => {
		const input = document.createElement("input");
		input.type = "file";
		input.accept = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
		input.onchange = convertAction;
		input.click();
	};

	const exportToCSV = () => {
		dispatch(getTranslationsFile(trad)).then((res) => {
			const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.payload.data.base64}`;
			const downloadLink = document.createElement("a");
			const fileName = `translations.xlsx`;
			downloadLink.href = linkSource;
			downloadLink.download = fileName;
			downloadLink.click();
		});
	};

	const keys = findKeyValues(Object.values(Object.entries(i18n.store.data)[0][1])[0])
		.filter((i) => i && i.split(",").length > 0 && isJson(i.split(",")[0]))
		.map((info) => JSON.parse(info.split(",")[0]));
	return (
		<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
			<Grid.Row>
				<Grid.Column style={{ maxWidth: 1250, padding: "50px 20px 50px 20px", margin: "auto", height: "93vh" }}>
					<div computer={16}>
						<LanguageSwitcher lang={lang} setActiveLanguage={changeLanguage} />
					</div>

					<div style={{ marginBottom: "25px" }}>
						<Label>
							<Icon name="numbered list" /> {keys.length}
						</Label>
						{/*   <Button  onClick={() => {
                        importCSV()
                        }}icon labelPosition='left'> <Icon name='upload' />
               Importer en CSV
            </Button> */}
						<Button
							onClick={() => {
								exportToCSV();
							}}
							icon
							labelPosition="left"
						>
							{" "}
							<Icon name="download" />
							Exporter en CSV
						</Button>
						{!filterDE && (
							<Button
								onClick={() => {
									setFilterEN(!filterEN);
								}}
								icon
								labelPosition="left"
							>
								{" "}
								<Icon name="filter" />
								{!filterEN ? "Manquants Anglais" : "Afficher tout"}
							</Button>
						)}
						{!filterEN && (
							<Button
								onClick={() => {
									setFilterDE(!filterDE);
								}}
								icon
								labelPosition="left"
							>
								{" "}
								<Icon name="filter" />
								{!filterDE ? "Manquants Allemand" : "Afficher tout"}
							</Button>
						)}
					</div>
					<div style={{ padding: "15px", height: "100%", overflowX: "auto" }}>
						<Grid textAlign="left" columns={4} divided>
							<Grid.Row>
								<Grid.Column style={styles.blocHeader}>Clé technique</Grid.Column>
								<Grid.Column style={styles.blocHeader}>Français</Grid.Column>
								<Grid.Column style={styles.blocHeader}>English</Grid.Column>
								<Grid.Column style={styles.blocHeader}>Deútsche</Grid.Column>
							</Grid.Row>
							{keys.map((key) => {
								let keyTab = key.split(".");
								let en =
									trad.en && trad.en[keyTab[0]] && trad.en[keyTab[0]][keyTab[1]]
										? trad.en[keyTab[0]][keyTab[1]] === ""
											? novalue
											: trad.en[keyTab[0]][keyTab[1]]
										: missing;
								let de =
									trad.de && trad.de[keyTab[0]] && trad.de[keyTab[0]][keyTab[1]]
										? trad.de[keyTab[0]][keyTab[1]] === ""
											? "null"
											: trad.de[keyTab[0]][keyTab[1]]
										: missing;
								if (
									(!filterEN || (filterEN && (en === missing || en === novalue))) &&
									(!filterDE || (filterDE && (de === missing || de === novalue)))
								)
									return (
										<Grid.Row key={`key-${key}`} style={styles.row}>
											<Grid.Column style={styles.blocWhite}>
												<span style={{ fontSize: "0.8em" }}>{key}</span>
											</Grid.Column>
											<Grid.Column style={styles.blocWhite}>
												{trad.fr && trad.fr[keyTab[0]] && trad.fr[keyTab[0]][keyTab[1]]
													? trad.fr[keyTab[0]][keyTab[1]] === ""
														? "null"
														: trad.fr[keyTab[0]][keyTab[1]]
													: missing}
											</Grid.Column>
											<Grid.Column style={styles.blocWhite}>{en}</Grid.Column>
											<Grid.Column style={styles.blocWhite}>{de}</Grid.Column>
										</Grid.Row>
									);
								return null;
							})}
						</Grid>
					</div>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};
